// import { RouteWithPermissions } from 'containers/route-with-permissions';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { BUSINNESS_FUNCTIONS } from 'constants/roles';
import { RouteWithPermissions } from 'containers/route-with-permissions';
import React from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';
import { ExtraDocumentRouting } from 'views/administration/extraDocument/ExtraDocumentRouting';
import { Index } from './athena/Index';

export const AdministrationRouting = () => {
    return (
        <Switch>
            <Route
                path="/administration/extra-document"
                component={ExtraDocumentRouting}
            />
            <RouteWithPermissions
                path="/administration/migrated-esso-rates"
                component={Index}
                functions={[BUSINNESS_FUNCTIONS.OCEAN_FACT_WRAPPER_LIST, BUSINNESS_FUNCTIONS.AIR_FACT_WRAPPER_LIST]}
                featuresToRestrict={[FEATURE_TOGGLES.FINOPS_DOWNLOAD_COMPARED_RATES]}
            />
        </Switch>
    );
};